/**
 * Resolve the API base URL.
 * On custom domains (e.g. www.mortalworks.art), the build-time URL
 * (gallery-hub-95.emergent.host) is cross-origin and may hang.
 * In that case, fall back to relative URLs so the browser uses
 * the same domain the user is visiting.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

function resolveApiBase() {
  if (!BACKEND_URL) return '/api';
  try {
    const backendOrigin = new URL(BACKEND_URL).origin;
    if (backendOrigin !== window.location.origin) {
      return '/api';
    }
  } catch {
    return '/api';
  }
  return `${BACKEND_URL}/api`;
}

export const API = resolveApiBase();
